import { inject, Injectable } from '@angular/core';
import { I18nextHttpBackendInitializer, OccEndpointsService } from '@spartacus/core';

@Injectable()
export class HisenseI18nextHttpBackendInitializer extends I18nextHttpBackendInitializer {
  protected occ = inject(OccEndpointsService);

  // Overriden to include baseSite:false option in the translations URL.
  protected override getLoadPath(_: string): string {
    return this.occ.buildUrl('translations', undefined, { baseSite: false });
  }
}
